import { useThemeUI } from '@theme-ui/core';
import { Theme } from '@theme-ui/css';

export function getSpace(
  theme: Theme | null,
  value: string | string[] | number | number[] | undefined
) {
  if (Array.isArray(value)) {
    return value.map((elem) => getOneSpace(theme?.space as string[], elem));
  }
  if (value && !Array.isArray(value)) {
    const space = getOneSpace(theme?.space as string[], value);
    if (space === undefined) {
      return value;
    } else {
      return getOneSpace(theme?.space as string[], value);
    }
  }
  return value;
}

function getOneSpace(themeSpaces: string[] | undefined, space: string | number) {
  if (themeSpaces) {
    return themeSpaces[space as any];
  } else {
    return `${space}px`;
  }
}

export function useSpace(value: number | undefined) {
  const { theme } = useThemeUI();
  if (value) {
    if (theme?.space) {
      return (theme.space as number[])[value];
    } else {
      return `${value}px`;
    }
  }
  return value;
}
